import React from 'react';
import { SubscriptionPlanId } from 'nekst-api';
import useFeatureToggleService from 'feature-toggle';

export default function useSubscriptionPlanFeaturesHelper() {
  const featureToggleService = useFeatureToggleService();

  const getFeatures = (id: SubscriptionPlanId) => {
    switch (id) {
      case SubscriptionPlanId.AGENT_LITE:
        return [
          'Single User Account',
          'Manage up to 5 Total Transactions',
          '5 Pre-Loaded, Customizable Workflows',
          'Unlimited Workflows',
          'Client Portals',
          'Assign Tasks only to Yourself',
          <b style={{ marginTop: '1rem', display: 'block' }}>Does Not Include:</b>,
          'SMS Tasks',
          'Create Transactions by Uploading a Signed Contract',
        ];
      case SubscriptionPlanId.AGENT_PRO:
        return [
          <b>Everything in Solo Lite Plus</b>,
          'Create Transactions by Uploading a Signed Contract',
          'Sync Contract Dates to Workflow Tasks',
          'Supports Contracts from up to 3 Markets of Operation',
          'Unlimited Transactions',
          'SMS Messaging',
        ];
      case SubscriptionPlanId.TEAM_PRO:
        return [
          <b>Everything in Solo Pro Plus</b>,
          'Collaborate with Multiple Team Members',
          'Assign Tasks to any Team Member',
          'Tag Team Members in Comments & Notes',
          'Customize Notifications',
          'Supports Contracts from up to 6 Markets of Operation',
          featureToggleService.isNewPriceEnabled() ? 'Includes 2 Seats: (1 Owner, 1 Admin)' : 'Includes 4 Seats: (1 Owner, 1 Admin, 2 Team Members)',
          'Additional Seats can be purchased',
        ];
      default:
        return [];
    }
  };

  return {
    getFeatures,
  };
}
